import { types } from "mobx-state-tree";

export const ItemMyLeadsModel = types.model("ItemMyLeadsModel", {
  id: types.maybe(types.number),
  date: types.string,
  firstName: types.optional(types.string, "-"),
  lastName: types.optional(types.string, "-"),
  phone: types.optional(types.string, "-"),
  email: types.string,
  source: types.optional(types.string, "-"),
  clientNotClient: types.optional(types.boolean, false),
  leadUserId: types.maybeNull(types.number),
});
export const RowsModel = types.model("ItemMyLeadsModel", {
  id: types.number,
  date: types.string,
  firstName: types.string,
  lastName: types.string,
  phone: types.string,
  email: types.string,
  source: types.string,
  clientNotClient: types.boolean,
});

export const LeadClientRowModel = types.model("LeadClientRowModel", {
  type: types.literal("leadClient"),
  id: types.number,
  date: types.string,
  firstName: types.string,
  lastName: types.string,
  phone: types.string,
  email: types.string,
  source: types.string,
  leadUserId: types.maybeNull(types.number),
});

export const CoachLeadRowModel = types.model("CoachLeadRowModel", {
  type: types.literal("coachLead"),
  id: types.number,
  date: types.string,
  firstName: types.string,
  lastName: types.string,
  phone: types.string,
  email: types.string,
  clientNotClient: types.string,
});

export const MyLeadsParamsModel = types.model("MyLeadsParamsModel", {
  page: types.maybe(types.number),
  size: types.maybe(types.number),
  orderByDesc: types.maybe(types.string),
  orderBy: types.maybe(types.string),
  lastName: types.maybe(types.string),
  email: types.maybe(types.string),
  endDate: types.maybe(types.string),
  startDate: types.maybe(types.string),
  source: types.maybe(types.string),
});
